webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(5);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vuexRouterSync = __webpack_require__(95);
	
	var _App = __webpack_require__(67);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	var vm = new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(94);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _dbfunctions = __webpack_require__(18);
	
	var _dbfunctions2 = _interopRequireDefault(_dbfunctions);
	
	var _loginform = __webpack_require__(76);
	
	var _loginform2 = _interopRequireDefault(_loginform);
	
	var _aboutus = __webpack_require__(68);
	
	var _aboutus2 = _interopRequireDefault(_aboutus);
	
	var _info_venue = __webpack_require__(75);
	
	var _info_venue2 = _interopRequireDefault(_info_venue);
	
	var _info_capetown = __webpack_require__(73);
	
	var _info_capetown2 = _interopRequireDefault(_info_capetown);
	
	var _info_2017committee = __webpack_require__(72);
	
	var _info_2017committee2 = _interopRequireDefault(_info_2017committee);
	
	var _info_delegateregistration = __webpack_require__(74);
	
	var _info_delegateregistration2 = _interopRequireDefault(_info_delegateregistration);
	
	var _scregister = __webpack_require__(78);
	
	var _scregister2 = _interopRequireDefault(_scregister);
	
	var _testpage = __webpack_require__(79);
	
	var _testpage2 = _interopRequireDefault(_testpage);
	
	var _manageusers = __webpack_require__(77);
	
	var _manageusers2 = _interopRequireDefault(_manageusers);
	
	var _dynamic = __webpack_require__(69);
	
	var _dynamic2 = _interopRequireDefault(_dynamic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/', component: _aboutus2.default }, { path: '/testpage', component: _testpage2.default }, { path: '/scregister', component: _scregister2.default }, { path: '/login', component: _loginform2.default }, { path: '/info_venue', component: _info_venue2.default }, { path: '/info_capetown', component: _info_capetown2.default }, { path: '/info_2017committee', component: _info_2017committee2.default }, { path: '/info_delegateregistration', component: _info_delegateregistration2.default }, { path: '/manageusers', component: _manageusers2.default }, { path: '/content/:cid', component: _dynamic2.default }];
	
	exports.default = new _vueRouter2.default({
	  routes: routes,
	  mode: 'history'
	});

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vuexfire2.default);
	_vue2.default.config.debug = true;
	
	_vuexfire2.default.mutations['AI/updateAuth'] = function (state, payload) {
	  state["authData"] = payload.payload;
	};
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    currentUser: {},
	    contacts: {},
	    users: {},
	    preauth: {},
	    authData: {},
	    preRegistrationData: {},
	    dynamic: {}
	  },
	  mutations: _vuexfire2.default.mutations,
	  actions: {
	    updateAuth: function updateAuth(context, payload) {
	      context.commit('AI/updateAuth', payload);
	    }
	  }
	
	});

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(21)
	
	/* template */
	var __vue_template__ = __webpack_require__(86)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dbfunctions = __webpack_require__(18);
	
	var _dbfunctions2 = _interopRequireDefault(_dbfunctions);
	
	var _headerblock = __webpack_require__(71);
	
	var _headerblock2 = _interopRequireDefault(_headerblock);
	
	var _footerblock = __webpack_require__(70);
	
	var _footerblock2 = _interopRequireDefault(_footerblock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    dbfunctions: _dbfunctions2.default,
	    headerblock: _headerblock2.default,
	    footerblock: _footerblock2.default
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _router = __webpack_require__(5);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var db = _firebase2.default.database();
	
	var queryString = function () {
	  var qs = document.location.search.split('+').join(' ');
	  var params = {},
	      tokens,
	      re = /[?&]?([^=]+)=([^&]*)/g;
	  while (tokens = re.exec(qs)) {
	    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
	  }
	  return params;
	}();
	exports.default = {
	  name: "aboutus",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData'
	  })),
	  data: function data() {
	    return {
	      txtEmail: '',
	      messageError: null,
	      messageSuccess: null
	    };
	  },
	
	  firebase: {
	    contacts: db.ref('contacts'),
	    preauth: db.ref('pre-auth')
	  },
	  methods: {
	    subscribeForInfo: function subscribeForInfo(evt) {
	      var email = this.txtEmail;
	      var $target = $(event.target);
	      this.messageError = null;
	      this.messageSuccess = null;
	
	      if (!regexEmail.test(email)) {
	        this.messageError = 'Please enter a valid email address.';
	        return;
	      }
	      $target.prop('disabled', true);
	      _firebase2.default.database().ref('contacts/').push({
	        "email": email,
	        entered: _firebase2.default.database.ServerValue.TIMESTAMP
	      }, $.proxy(function (error) {
	        $target.prop('disabled', false);
	        if (error) {
	          this.messageError = 'Sorry. An error has occured';
	        } else {
	          this.messageSuccess = 'Thank you for submitting your details. We will contact you with further details.';
	          $target.closest("div.input-group").hide();
	        }
	      }, this));
	    },
	    focusNextField: function focusNextField(event) {
	      $(event.target).parent().next("div").find("input").focus();
	    }
	  },
	  components: {}
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _store = __webpack_require__(12);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: "AIzaSyBRG8MJ3_KDZz42GABLHAp2YsVcawux5xE",
	  authDomain: "aidsimpact-e87b7.firebaseapp.com",
	  databaseURL: "https://aidsimpact-e87b7.firebaseio.com",
	  storageBucket: "aidsimpact-e87b7.appspot.com",
	  messagingSenderId: "555300387684"
	};
	var firebaseApp = _firebase2.default.initializeApp(config);
	var db = _firebase2.default.database();
	var firebaseAuth = _firebase2.default.auth();
	
	exports.default = {
	  store: _store2.default,
	  created: function created() {
	    this.listenAuth();
	  },
	  firebase: {},
	  watch: {
	    authData: function authData(val) {
	      if (!val) {}
	    }
	  },
	  methods: {
	    listenAuth: function listenAuth() {
	      firebaseAuth.onAuthStateChanged(function (authData) {
	        _store2.default.dispatch({ type: 'updateAuth', payload: authData });
	        if (authData) {}
	      });
	    },
	    checkAuth: function checkAuth() {}
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _router = __webpack_require__(5);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var db = _firebase2.default.database();
	exports.default = {
	  name: "dynamic",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData',
	    dynamic: 'dynamic'
	  })),
	  data: function data() {
	    return {};
	  },
	
	  firebase: {
	    dynamic: db.ref('dynamic') },
	  methods: {},
	  components: {}
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _router = __webpack_require__(5);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var db = _firebase2.default.database();
	var firebaseAuth = _firebase2.default.auth();
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData',
	    contacts: 'contacts',
	    currentUser: 'currentUser'
	  })),
	  created: function created() {
	    this.listenAuth();
	  },
	  data: function data() {
	    return {
	      messageError: null,
	      messageSuccess: null
	    };
	  },
	
	  firebase: {},
	  methods: {
	    listenAuth: function listenAuth() {
	      var self = this;
	      firebaseAuth.onAuthStateChanged(function (user) {
	        if (user) {
	          self.$bindAsObject('currentUser', db.ref('users/' + user.uid));
	        } else {
	          if (self.currentUser) self.$unbind('currentUser');
	        }
	      });
	    },
	    userLogout: function userLogout(evt) {
	      this.messageError = null;
	      this.messageSuccess = null;
	      if (_firebase2.default.auth().currentUser) {
	        _firebase2.default.auth().signOut();
	      }
	      _router2.default.push("/");
	    }
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "info_2017committee"
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "info_capetown"
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "info_delegateregistration"
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "info_venue"
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var blankUser = { name: null,
	  email: null,
	  type: null };
	
	
	var db = _firebase2.default.database();
	var firebaseAuth = _firebase2.default.auth();
	exports.default = {
	  name: "loginform",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData',
	    currentUser: 'currentUser'
	  })),
	  data: function data() {
	    return {
	      txtEmail: '',
	      txtPassword: '',
	      messageError: null,
	      messageSuccess: null
	    };
	  },
	
	  methods: {
	    userLogin: function userLogin(evt) {
	      var self = this;
	      var email = self.txtEmail;
	      var password = self.txtPassword;
	      self.messageError = null;
	      self.messageSuccess = null;
	
	      if (!regexEmail.test(email)) {
	        self.messageError = 'Please enter a valid email address.';
	        return;
	      }
	      if (password.length < 4) {
	        self.messageError = 'Please enter a valid password.';
	        return;
	      }
	
	      _firebase2.default.auth().signInWithEmailAndPassword(email, password).catch(function (error) {
	        if (error.code === 'auth/wrong-password') {
	          self.messageError = 'Incorrect username and/or password.';
	        } else if (error.code === 'auth/user-not-found') {
	          self.messageError = 'Incorrect username and/or password.';
	        } else {
	          self.messageError = error.message;
	        }
	      });
	    },
	    userResetPassword: function userResetPassword(evt) {
	      var email = this.txtEmail;
	
	      _firebase2.default.auth().sendPasswordResetEmail(email).then($.proxy(function () {
	        this.messageError = '';
	        this.messageSuccess = 'Password reset email sent to ' + email;
	      }, this)).catch($.proxy(function (error) {
	        var errorCode = error.code;
	        var errorMessage = error.message;
	        if (errorCode == 'auth/invalid-email') {
	          this.messageError = "The above email address is not valid. Please confirm and try again.";
	        } else if (errorCode == 'auth/user-not-found') {
	          this.messageError = "The above email address cannot be found, please check that it has been entered correctly.";
	        }
	      }, this));
	    },
	    focusNextField: function focusNextField(event) {
	      $(event.target).parent().next("div").find("input").focus();
	    }
	  },
	  components: {}
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var regexURL = /(\?|\&)([^=]+)\=([^&]+)$/;
	var blankUser = { name: null,
	  email: null,
	  type: null };
	
	var db = _firebase2.default.database();
	exports.default = {
	  name: "manageusers",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData',
	    contacts: 'contacts',
	    currentUser: 'currentUser',
	    route: 'route',
	    users: 'users'
	  })),
	  firebase: {
	    users: db.ref('users').orderByChild("surname")
	  },
	  filters: {
	    epochtoreal: function epochtoreal(value) {
	      if (value) {
	        return moment(value).format('YYYY/MM/DD-HH:mm');
	      } else {
	        return "-";
	      }
	    },
	    yesno: function yesno(value) {
	      return value ? "Yes" : "No";
	    },
	    tick: function tick(value) {
	      return value ? "<i class=\"fa fa-check\" aria-hidden=\"true\"></i>" : "No";
	    }
	  },
	  data: function data() {
	    return {
	      messageError: null,
	      messageSuccess: null
	    };
	  },
	
	  methods: {
	    focusNextField: function focusNextField(event) {
	      $(event.target).parent().next("div").find("input").focus();
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(3);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var regexURL = /(\?|\&)([^=]+)\=([^&]+)$/;
	var blankUser = { name: null,
	  email: null,
	  type: null };
	
	var db = _firebase2.default.database();
	exports.default = {
	  name: "scregister",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    authData: 'authData',
	    contacts: 'contacts',
	    currentUser: 'currentUser',
	    route: 'route'
	  })),
	  data: function data() {
	    return {
	      txtEmail: '',
	      txtPassword: '',
	      messageError: null,
	      messageSuccess: null,
	      registrationData: { forename: '',
	        surname: '',
	        type: '',
	        sex: '',
	        email: '',
	        country: '',
	        organisation: '',
	        speciality: '',
	        password1: '',
	        password2: '',
	        agreement: false }
	    };
	  },
	
	  methods: {
	    scRegister: function scRegister(evt) {
	      var $target = $(event.target);
	      var formData = this.registrationData;
	      this.messageError = null;
	      this.messageSuccess = null;
	
	      if (formData.password1 != formData.password2) {
	        this.messageError = 'Please ensure that both passwords match.';
	        return;
	      }
	      if (formData.password1.length < 4) {
	        this.messageError = 'Please enter a valid password.';
	        return;
	      }
	      if (!regexEmail.test(formData.email)) {
	        this.messageError = 'Please enter a valid email address.';
	        return;
	      }
	      if (!formData.agreement) {
	        this.messageError = 'You must agree to the terms and conditions before you are able to sign up.';
	        return;
	      }
	      if (!this.route.query.uid) {
	        this.messageError = 'The form you are trying to submit cannot be authenticated.  Please use the link as sent via email.';
	        return;
	      }
	
	      $target.prop('disabled', true);
	      _firebase2.default.database().ref('users/' + this.route.query.uid + "/").set({
	        email: formData.email,
	        created: _firebase2.default.database.ServerValue.TIMESTAMP
	      }, $.proxy(function (error) {
	        $target.prop('disabled', false);
	        if (error) {
	          var errorCode = error.code;
	          var errorMessage = error.message;
	          if (errorCode == 'PERMISSION_DENIED') {
	            this.messageError = "The form you are trying to submit cannot be authenticated.  Please use the link as sent via email.";
	          } else {
	            this.messageError = 'Sorry. An error has occured';
	          }
	        } else {
	          _firebase2.default.auth().createUserWithEmailAndPassword(formData.email, formData.password1).then($.proxy(function (user) {
	            _firebase2.default.database().ref('users/' + user.uid + "/").set({
	              forename: formData.forename,
	              surname: formData.surname,
	              type: formData.type,
	              sex: formData.sex,
	              email: formData.email,
	              country: formData.country,
	              organisation: formData.organisation,
	              speciality: formData.speciality,
	              agreement: formData.agreement,
	              scientificcommittee: true,
	              ai2016: true,
	              inviteaccepted: _firebase2.default.database.ServerValue.TIMESTAMP
	            }, $.proxy(function (error) {
	              if (error) {
	                var errorCode = error.code;
	                var errorMessage = error.message;
	                if (errorCode == 'PERMISSION_DENIED') {
	                  this.messageError = error.message;
	                }
	              } else {
	                _firebase2.default.database().ref('users/' + this.route.query.uid).remove();
	                _firebase2.default.database().ref('pre-auth/' + this.route.query.uid).remove();
	                this.messageSuccess = 'Thank you for submitting your details. You\'ve successfully registered and logged in.';
	                $target.closest("form").hide();
	              }
	            }, this));
	          }, this)).catch($.proxy(function (error) {
	            var errorCode = error.code;
	            var errorMessage = error.message;
	            this.messageError = errorMessage;
	            this.messageSuccess = null;
	          }, this));
	        }
	      }, this));
	    },
	    focusNextField: function focusNextField(event) {
	      $(event.target).parent().next("div").find("input").focus();
	    }
	  },
	  components: {}
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "testpage"
	};

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/venue-map.7b5e144.jpg";

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(61)
	
	/* script */
	__vue_exports__ = __webpack_require__(19)
	
	/* template */
	var __vue_template__ = __webpack_require__(80)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(20)
	
	/* template */
	var __vue_template__ = __webpack_require__(89)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(22)
	
	/* template */
	var __vue_template__ = __webpack_require__(83)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(23)
	
	/* template */
	var __vue_template__ = __webpack_require__(85)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(24)
	
	/* template */
	var __vue_template__ = __webpack_require__(84)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(25)
	
	/* template */
	var __vue_template__ = __webpack_require__(88)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(26)
	
	/* template */
	var __vue_template__ = __webpack_require__(92)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(27)
	
	/* template */
	var __vue_template__ = __webpack_require__(91)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(28)
	
	/* template */
	var __vue_template__ = __webpack_require__(90)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(29)
	
	/* template */
	var __vue_template__ = __webpack_require__(87)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(30)
	
	/* template */
	var __vue_template__ = __webpack_require__(82)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(31)
	
	/* template */
	var __vue_template__ = __webpack_require__(81)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(93)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('dbfunctions'), " ", _h('headerblock'), " ", _h('transition', {
	    attrs: {
	      "appear": "",
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_h('router-view')]), " ", _h('footerblock')])
	}},staticRenderFns: []}

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [(this.route.query.uid || (this.currentUser && this.currentUser.type == 'administrator')) ? _h('div', {
	    staticClass: "container mainContent"
	  }, [_m(0), " ", _h('form', {
	    staticClass: "form-horizontal",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        scRegister($event)
	      }
	    }
	  }, [(this.authData && currentUser.type == 'administrator') ? _h('h3', ["System Data"]) : _e(), " ", (this.authData && currentUser.type == 'administrator') ? _h('div', {
	    staticClass: "form-group"
	  }, [_m(1), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('p', {
	    staticClass: "form-control-static"
	  }, [_s(route.query.uid)])])]) : _e(), " ", _m(2), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(3), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('select', {
	    directives: [{
	      name: "model",
	      value: (registrationData.title),
	      expression: "registrationData.title"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "title"
	    },
	    on: {
	      "change": function($event) {
	        registrationData.title = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          return "_value" in o ? o._value : o.value
	        })[0]
	      }
	    }
	  }, [_m(4), " ", _m(5), " ", _m(6), " ", _m(7), " ", _m(8), " ", _m(9), " ", _m(10), " ", _m(11), " ", _m(12), " ", _m(13), " ", _m(14), " ", _m(15), " ", _m(16), " ", _m(17), " ", _m(18), " ", _m(19), " ", _m(20), " ", _m(21), " ", _m(22), " ", _m(23), " ", _m(24), " ", _m(25), " ", _m(26), " ", _m(27), " ", _m(28), " ", _m(29), " ", _m(30), " ", _m(31), " ", _m(32), " ", _m(33), " ", _m(34), " ", _m(35), " ", _m(36), " ", _m(37), " ", _m(38), " ", _m(39), " ", _m(40)])])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(41), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.forename),
	      expression: "registrationData.forename"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "forename",
	      "placeholder": "First name"
	    },
	    domProps: {
	      "value": _s(registrationData.forename)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.forename = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(42), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.surname),
	      expression: "registrationData.surname"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "surname",
	      "placeholder": "Surname"
	    },
	    domProps: {
	      "value": _s(registrationData.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.surname = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(43), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('label', {
	    staticClass: "radio-inline"
	  }, [_h('input', {
	    attrs: {
	      "type": "radio",
	      "name": "sex",
	      "value": "female"
	    },
	    domProps: {
	      "checked": _q(registrationData.sex, "female")
	    },
	    on: {
	      "change": function($event) {
	        registrationData.sex = "female"
	      }
	    }
	  }), " Female\n          "]), " ", _h('label', {
	    staticClass: "radio-inline"
	  }, [_h('input', {
	    attrs: {
	      "type": "radio",
	      "name": "sex",
	      "value": "male"
	    },
	    domProps: {
	      "checked": _q(registrationData.sex, "male")
	    },
	    on: {
	      "change": function($event) {
	        registrationData.sex = "male"
	      }
	    }
	  }), " Male\n          "])])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(44), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.email),
	      expression: "registrationData.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": _s(registrationData.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.email = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(45), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('select', {
	    directives: [{
	      name: "model",
	      value: (registrationData.country),
	      expression: "registrationData.country"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "country"
	    },
	    on: {
	      "change": function($event) {
	        registrationData.country = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          return "_value" in o ? o._value : o.value
	        })[0]
	      }
	    }
	  }, [_m(46), " ", _m(47), " ", _m(48), " ", _m(49), " ", _m(50), " ", _m(51), " ", _m(52), " ", _m(53), " ", _m(54), " ", _m(55), " ", _m(56), " ", _m(57), " ", _m(58), " ", _m(59), " ", _m(60), " ", _m(61), " ", _m(62), " ", _m(63), " ", _m(64), " ", _m(65), " ", _m(66), " ", _m(67), " ", _m(68), " ", _m(69), " ", _m(70), " ", _m(71), " ", _m(72), " ", _m(73), " ", _m(74), " ", _m(75), " ", _m(76), " ", _m(77), " ", _m(78), " ", _m(79), " ", _m(80), " ", _m(81), " ", _m(82), " ", _m(83), " ", _m(84), " ", _m(85), " ", _m(86), " ", _m(87), " ", _m(88), " ", _m(89), " ", _m(90), " ", _m(91), " ", _m(92), " ", _m(93), " ", _m(94), " ", _m(95), " ", _m(96), " ", _m(97), " ", _m(98), " ", _m(99), " ", _m(100), " ", _m(101), " ", _m(102), " ", _m(103), " ", _m(104), " ", _m(105), " ", _m(106), " ", _m(107), " ", _m(108), " ", _m(109), " ", _m(110), " ", _m(111), " ", _m(112), " ", _m(113), " ", _m(114), " ", _m(115), " ", _m(116), " ", _m(117), " ", _m(118), " ", _m(119), " ", _m(120), " ", _m(121), " ", _m(122), " ", _m(123), " ", _m(124), " ", _m(125), " ", _m(126), " ", _m(127), " ", _m(128), " ", _m(129), " ", _m(130), " ", _m(131), " ", _m(132), " ", _m(133), " ", _m(134), " ", _m(135), " ", _m(136), " ", _m(137), " ", _m(138), " ", _m(139), " ", _m(140), " ", _m(141), " ", _m(142), " ", _m(143), " ", _m(144), " ", _m(145), " ", _m(146), " ", _m(147), " ", _m(148), " ", _m(149), " ", _m(150), " ", _m(151), " ", _m(152), " ", _m(153), " ", _m(154), " ", _m(155), " ", _m(156), " ", _m(157), " ", _m(158), " ", _m(159), " ", _m(160), " ", _m(161), " ", _m(162), " ", _m(163), " ", _m(164), " ", _m(165), " ", _m(166), " ", _m(167), " ", _m(168), " ", _m(169), " ", _m(170), " ", _m(171), " ", _m(172), " ", _m(173), " ", _m(174), " ", _m(175), " ", _m(176), " ", _m(177), " ", _m(178), " ", _m(179), " ", _m(180), " ", _m(181), " ", _m(182), " ", _m(183), " ", _m(184), " ", _m(185), " ", _m(186), " ", _m(187), " ", _m(188), " ", _m(189), " ", _m(190), " ", _m(191), " ", _m(192), " ", _m(193), " ", _m(194), " ", _m(195), " ", _m(196), " ", _m(197), " ", _m(198), " ", _m(199), " ", _m(200), " ", _m(201), " ", _m(202), " ", _m(203), " ", _m(204), " ", _m(205), " ", _m(206), " ", _m(207), " ", _m(208), " ", _m(209), " ", _m(210), " ", _m(211), " ", _m(212), " ", _m(213), " ", _m(214), " ", _m(215), " ", _m(216), " ", _m(217), " ", _m(218), " ", _m(219), " ", _m(220), " ", _m(221), " ", _m(222), " ", _m(223), " ", _m(224), " ", _m(225), " ", _m(226), " ", _m(227), " ", _m(228), " ", _m(229), " ", _m(230), " ", _m(231), " ", _m(232), " ", _m(233), " ", _m(234), " ", _m(235), " ", _m(236), " ", _m(237), " ", _m(238), " ", _m(239), " ", _m(240), " ", _m(241), " ", _m(242), " ", _m(243), " ", _m(244), " ", _m(245), " ", _m(246), " ", _m(247), " ", _m(248), " ", _m(249), " ", _m(250), " ", _m(251), " ", _m(252), " ", _m(253), " ", _m(254), " ", _m(255), " ", _m(256), " ", _m(257), " ", _m(258), " ", _m(259), " ", _m(260), " ", _m(261), " ", _m(262), " ", _m(263), " ", _m(264), " ", _m(265), " ", _m(266), " ", _m(267), " ", _m(268), " ", _m(269), " ", _m(270), " ", _m(271), " ", _m(272), " ", _m(273), " ", _m(274), " ", _m(275), " ", _m(276), " ", _m(277), " ", _m(278), " ", _m(279), " ", _m(280), " ", _m(281), " ", _m(282), " ", _m(283), " ", _m(284), " ", _m(285)])])]), " ", _m(286), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(287), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.organisation),
	      expression: "registrationData.organisation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "organisation",
	      "placeholder": "Organisation"
	    },
	    domProps: {
	      "value": _s(registrationData.organisation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.organisation = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(288), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.speciality),
	      expression: "registrationData.speciality"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "speciality",
	      "placeholder": "Speciality"
	    },
	    domProps: {
	      "value": _s(registrationData.speciality)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.speciality = $event.target.value
	      }
	    }
	  })])]), " ", _m(289), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(290), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.password1),
	      expression: "registrationData.password1"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": _s(registrationData.password1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.password1 = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_m(291), " ", _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (registrationData.password2),
	      expression: "registrationData.password2"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "confirmpassword",
	      "placeholder": "Confirm Password"
	    },
	    domProps: {
	      "value": _s(registrationData.password2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        registrationData.password2 = $event.target.value
	      }
	    }
	  })])]), " ", _m(292), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', {
	    staticClass: "col-sm-2 control-label"
	  }, [_h('input', {
	    attrs: {
	      "type": "checkbox",
	      "id": "agreement",
	      "value": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(registrationData.agreement) ? _i(registrationData.agreement, "true") > -1 : _q(registrationData.agreement, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = registrationData.agreement,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "true",
	            $$i = _i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (registrationData.agreement = $$a.concat($$v))
	          } else {
	            $$i > -1 && (registrationData.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          registrationData.agreement = $$c
	        }
	      }
	    }
	  })]), " ", _m(293)]), " ", _m(294)]), " ", (messageError) ? _h('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageError)]) : _e(), " ", (messageSuccess) ? _h('div', {
	    staticClass: "alert alert-success",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageSuccess)]) : _e()]) : _h('div', {
	    staticClass: "container mainContent"
	  }, [_h('h2', ["An error has occured"]), " ", _h('p', ["Sorry, but you're not authorised to view this page."])]), " "])
	}},staticRenderFns: [function (){with(this) {
	  return _h('h2', ["Scientific Committee Registration"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "uid"
	    }
	  }, ["uid"])
	}},function (){with(this) {
	  return _h('h3', ["Personal Details"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "title"
	    }
	  }, ["Title"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": ""
	    }
	  })
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, ["Mr"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, ["Mrs"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, ["Miss"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, ["Ms"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, ["Mx (gender-netural)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, ["Dr"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, ["Professor"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, ["The Rt Revd Dr"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, ["The Most Revd"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, ["The Rt Revd"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, ["The Revd Canon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, ["The Revd"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, ["The Rt Revd Professor"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, ["The Ven"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, ["The Most Revd Dr"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "16"
	    }
	  }, ["Rabbi"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "17"
	    }
	  }, ["Canon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "18"
	    }
	  }, ["Dame"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "19"
	    }
	  }, ["Chief"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "20"
	    }
	  }, ["Sister"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "21"
	    }
	  }, ["Reverend"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "22"
	    }
	  }, ["Major"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "23"
	    }
	  }, ["Other"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "24"
	    }
	  }, ["Cllr"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "25"
	    }
	  }, ["Sir"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "26"
	    }
	  }, ["Rt Hon Lord"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "27"
	    }
	  }, ["Rt Hon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "28"
	    }
	  }, ["Lord"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "29"
	    }
	  }, ["Viscount"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "30"
	    }
	  }, ["Viscountess"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "31"
	    }
	  }, ["Baroness"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "32"
	    }
	  }, ["Captain"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "33"
	    }
	  }, ["Master"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "34"
	    }
	  }, ["Very Revd"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "35"
	    }
	  }, ["Lady"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "36"
	    }
	  }, ["MP"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "forename"
	    }
	  }, ["First name"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "surname"
	    }
	  }, ["Surname"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "sex"
	    }
	  }, ["Sex"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, ["Email"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "country"
	    }
	  }, ["Country"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": ""
	    }
	  })
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AFG"
	    }
	  }, ["Afghanistan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ALB"
	    }
	  }, ["Albania"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DZA"
	    }
	  }, ["Algeria"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ASM"
	    }
	  }, ["American Samoa"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AND"
	    }
	  }, ["Andorra"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AGO"
	    }
	  }, ["Angola"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AIA"
	    }
	  }, ["Anguilla"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ATA"
	    }
	  }, ["Antarctica"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ATG"
	    }
	  }, ["Antigua And Barbuda"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ARG"
	    }
	  }, ["Argentina"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ARM"
	    }
	  }, ["Armenia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ABW"
	    }
	  }, ["Aruba"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AUS"
	    }
	  }, ["Australia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AUT"
	    }
	  }, ["Austria"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "AZE"
	    }
	  }, ["Azerbaijan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BHS"
	    }
	  }, ["Bahamas"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BHR"
	    }
	  }, ["Bahrain"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BGD"
	    }
	  }, ["Bangladesh"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BRB"
	    }
	  }, ["Barbados"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BLR"
	    }
	  }, ["Belarus"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BEL"
	    }
	  }, ["Belgium"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BLZ"
	    }
	  }, ["Belize"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BEN"
	    }
	  }, ["Benin"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BMU"
	    }
	  }, ["Bermuda"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BTN"
	    }
	  }, ["Bhutan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BOL"
	    }
	  }, ["Bolivia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BIH"
	    }
	  }, ["Bosnia And Herzegowina"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BWA"
	    }
	  }, ["Botswana"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BVT"
	    }
	  }, ["Bouvet Island"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BRA"
	    }
	  }, ["Brazil"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IOT"
	    }
	  }, ["British Indian Ocean Territory"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BRN"
	    }
	  }, ["Brunei Darussalam"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BGR"
	    }
	  }, ["Bulgaria"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BFA"
	    }
	  }, ["Burkina Faso"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "BDI"
	    }
	  }, ["Burundi"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KHM"
	    }
	  }, ["Cambodia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CMR"
	    }
	  }, ["Cameroon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CAN"
	    }
	  }, ["Canada"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CPV"
	    }
	  }, ["Cape Verde"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CYM"
	    }
	  }, ["Cayman Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CAF"
	    }
	  }, ["Central African Republic"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TCD"
	    }
	  }, ["Chad"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CHL"
	    }
	  }, ["Chile"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CHN"
	    }
	  }, ["China"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CXR"
	    }
	  }, ["Christmas Island"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CCK"
	    }
	  }, ["Cocos (Keeling) Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "COL"
	    }
	  }, ["Colombia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "COM"
	    }
	  }, ["Comoros"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "COG"
	    }
	  }, ["Congo"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "COK"
	    }
	  }, ["Cook Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CRI"
	    }
	  }, ["Costa Rica"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CIV"
	    }
	  }, ["Cote D'ivoire"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HRV"
	    }
	  }, ["Croatia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CUB"
	    }
	  }, ["Cuba"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CYP"
	    }
	  }, ["Cyprus"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CZE"
	    }
	  }, ["Czech Republic"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DNK"
	    }
	  }, ["Denmark"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DJI"
	    }
	  }, ["Djibouti"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DMA"
	    }
	  }, ["Dominica"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DOM"
	    }
	  }, ["Dominican Republic"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TMP"
	    }
	  }, ["East Timor"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ECU"
	    }
	  }, ["Ecuador"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "EGY"
	    }
	  }, ["Egypt"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SLV"
	    }
	  }, ["El Salvador"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GNQ"
	    }
	  }, ["Equatorial Guinea"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ERI"
	    }
	  }, ["Eritrea"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "EST"
	    }
	  }, ["Estonia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ETH"
	    }
	  }, ["Ethiopia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FLK"
	    }
	  }, ["Falkland Islands (Malvinas)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FRO"
	    }
	  }, ["Faroe Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FJI"
	    }
	  }, ["Fiji"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FIN"
	    }
	  }, ["Finland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FRA"
	    }
	  }, ["France"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FXX"
	    }
	  }, ["France, Metropolitan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GUF"
	    }
	  }, ["French Guiana"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PYF"
	    }
	  }, ["French Polynesia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ATF"
	    }
	  }, ["French Southern Territories"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GAB"
	    }
	  }, ["Gabon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GMB"
	    }
	  }, ["Gambia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GEO"
	    }
	  }, ["Georgia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "DEU"
	    }
	  }, ["Germany"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GHA"
	    }
	  }, ["Ghana"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GIB"
	    }
	  }, ["Gibraltar"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GRC"
	    }
	  }, ["Greece"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GRL"
	    }
	  }, ["Greenland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GRD"
	    }
	  }, ["Grenada"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GLP"
	    }
	  }, ["Guadeloupe"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GUM"
	    }
	  }, ["Guam"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GTM"
	    }
	  }, ["Guatemala"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GIN"
	    }
	  }, ["Guinea"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GNB"
	    }
	  }, ["Guinea-Bissau"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GUY"
	    }
	  }, ["Guyana"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HTI"
	    }
	  }, ["Haiti"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HMD"
	    }
	  }, ["Heard And Mc Donald Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HND"
	    }
	  }, ["Honduras"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HKG"
	    }
	  }, ["Hong Kong"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "HUN"
	    }
	  }, ["Hungary"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ISL"
	    }
	  }, ["Iceland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IND"
	    }
	  }, ["India"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IDN"
	    }
	  }, ["Indonesia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IRN"
	    }
	  }, ["Iran (Islamic Republic Of)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IRQ"
	    }
	  }, ["Iraq"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "IRL"
	    }
	  }, ["Ireland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ISR"
	    }
	  }, ["Israel"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ITA"
	    }
	  }, ["Italy"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "JAM"
	    }
	  }, ["Jamaica"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "JPN"
	    }
	  }, ["Japan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "JOR"
	    }
	  }, ["Jordan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KAZ"
	    }
	  }, ["Kazakhstan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KEN"
	    }
	  }, ["Kenya"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KIR"
	    }
	  }, ["Kiribati"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PRK"
	    }
	  }, ["Korea, Democratic People's Republic Of"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KOR"
	    }
	  }, ["Korea, Republic Of"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KWT"
	    }
	  }, ["Kuwait"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KGZ"
	    }
	  }, ["Kyrgyzstan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LAO"
	    }
	  }, ["Lao People's Democratic Republic"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LVA"
	    }
	  }, ["Latvia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LBN"
	    }
	  }, ["Lebanon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LSO"
	    }
	  }, ["Lesotho"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LBR"
	    }
	  }, ["Liberia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LBY"
	    }
	  }, ["Libyan Arab Jamahiriya"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LIE"
	    }
	  }, ["Liechtenstein"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LTU"
	    }
	  }, ["Lithuania"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LUX"
	    }
	  }, ["Luxembourg"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MAC"
	    }
	  }, ["Macau"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MKD"
	    }
	  }, ["Macedonia, The Former Yugoslav Republic Of"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MDG"
	    }
	  }, ["Madagascar"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MWI"
	    }
	  }, ["Malawi"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MYS"
	    }
	  }, ["Malaysia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MDV"
	    }
	  }, ["Maldives"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MLI"
	    }
	  }, ["Mali"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MLT"
	    }
	  }, ["Malta"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MHL"
	    }
	  }, ["Marshall Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MTQ"
	    }
	  }, ["Martinique"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MRT"
	    }
	  }, ["Mauritania"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MUS"
	    }
	  }, ["Mauritius"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MYT"
	    }
	  }, ["Mayotte"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MEX"
	    }
	  }, ["Mexico"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "FSM"
	    }
	  }, ["Micronesia (Federated States Of)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MDA"
	    }
	  }, ["Moldova, Republic Of"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MCO"
	    }
	  }, ["Monaco"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MNG"
	    }
	  }, ["Mongolia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MSR"
	    }
	  }, ["Montserrat"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MAR"
	    }
	  }, ["Morocco"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MOZ"
	    }
	  }, ["Mozambique"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MMR"
	    }
	  }, ["Myanmar"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NAM"
	    }
	  }, ["Namibia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NRU"
	    }
	  }, ["Nauru"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NPL"
	    }
	  }, ["Nepal"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NLD"
	    }
	  }, ["Netherlands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ANT"
	    }
	  }, ["Netherlands Antilles"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NCL"
	    }
	  }, ["New Caledonia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NZL"
	    }
	  }, ["New Zealand"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NIC"
	    }
	  }, ["Nicaragua"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NER"
	    }
	  }, ["Niger"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NGA"
	    }
	  }, ["Nigeria"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NIU"
	    }
	  }, ["Niue"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NFK"
	    }
	  }, ["Norfolk Island"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "MNP"
	    }
	  }, ["Northern Mariana Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "NOR"
	    }
	  }, ["Norway"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "OMN"
	    }
	  }, ["Oman"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PAK"
	    }
	  }, ["Pakistan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PLW"
	    }
	  }, ["Palau"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PAN"
	    }
	  }, ["Panama"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PNG"
	    }
	  }, ["Papua New Guinea"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PRY"
	    }
	  }, ["Paraguay"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PER"
	    }
	  }, ["Peru"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PHL"
	    }
	  }, ["Philippines"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PCN"
	    }
	  }, ["Pitcairn"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "POL"
	    }
	  }, ["Poland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PRT"
	    }
	  }, ["Portugal"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "PRI"
	    }
	  }, ["Puerto Rico"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "QAT"
	    }
	  }, ["Qatar"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "REU"
	    }
	  }, ["Reunion"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ROM"
	    }
	  }, ["Romania"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "RUS"
	    }
	  }, ["Russian Federation"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "RWA"
	    }
	  }, ["Rwanda"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "KNA"
	    }
	  }, ["Saint Kitts And Nevis"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LCA"
	    }
	  }, ["Saint Lucia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VCT"
	    }
	  }, ["Saint Vincent And The Grenadines"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "WSM"
	    }
	  }, ["Samoa"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SMR"
	    }
	  }, ["San Marino"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "STP"
	    }
	  }, ["Sao Tome And Principe"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SAU"
	    }
	  }, ["Saudi Arabia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SEN"
	    }
	  }, ["Senegal"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SYC"
	    }
	  }, ["Seychelles"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SLE"
	    }
	  }, ["Sierra Leone"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SGP"
	    }
	  }, ["Singapore"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SVK"
	    }
	  }, ["Slovakia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SVN"
	    }
	  }, ["Slovenia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SLB"
	    }
	  }, ["Solomon Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SOM"
	    }
	  }, ["Somalia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ZAF"
	    }
	  }, ["South Africa"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SGS"
	    }
	  }, ["South Georgia And The South Sandwich Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ESP"
	    }
	  }, ["Spain"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "LKA"
	    }
	  }, ["Sri Lanka"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SHN"
	    }
	  }, ["St. Helena"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SPM"
	    }
	  }, ["St. Pierre And Miquelon"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SDN"
	    }
	  }, ["Sudan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SUR"
	    }
	  }, ["Suriname"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SJM"
	    }
	  }, ["Svalbard And Jan Mayen Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SWZ"
	    }
	  }, ["Swaziland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SWE"
	    }
	  }, ["Sweden"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "CHE"
	    }
	  }, ["Switzerland"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "SYR"
	    }
	  }, ["Syrian Arab Republic"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TWN"
	    }
	  }, ["Taiwan, Province Of China"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TJK"
	    }
	  }, ["Tajikistan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TZA"
	    }
	  }, ["Tanzania, United Republic Of"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "THA"
	    }
	  }, ["Thailand"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TGO"
	    }
	  }, ["Togo"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TKL"
	    }
	  }, ["Tokelau"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TON"
	    }
	  }, ["Tonga"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TTO"
	    }
	  }, ["Trinidad And Tobago"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TUN"
	    }
	  }, ["Tunisia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TUR"
	    }
	  }, ["Turkey"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TKM"
	    }
	  }, ["Turkmenistan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TCA"
	    }
	  }, ["Turks And Caicos Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "TUV"
	    }
	  }, ["Tuvalu"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "UGA"
	    }
	  }, ["Uganda"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "UKR"
	    }
	  }, ["Ukraine"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ARE"
	    }
	  }, ["United Arab Emirates"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "GBR"
	    }
	  }, ["United Kingdom"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "USA"
	    }
	  }, ["United States"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "UMI"
	    }
	  }, ["United States Minor Outlying Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "URY"
	    }
	  }, ["Uruguay"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "UZB"
	    }
	  }, ["Uzbekistan"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VUT"
	    }
	  }, ["Vanuatu"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VAT"
	    }
	  }, ["Vatican City State (Holy See)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VEN"
	    }
	  }, ["Venezuela"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VNM"
	    }
	  }, ["Viet Nam"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VGB"
	    }
	  }, ["Virgin Islands (British)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "VIR"
	    }
	  }, ["Virgin Islands (U.S.)"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "WLF"
	    }
	  }, ["Wallis And Futuna Islands"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ESH"
	    }
	  }, ["Western Sahara"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "YEM"
	    }
	  }, ["Yemen"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "YUG"
	    }
	  }, ["Yugoslavia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ZAR"
	    }
	  }, ["Zaire"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ZMB"
	    }
	  }, ["Zambia"])
	}},function (){with(this) {
	  return _h('option', {
	    attrs: {
	      "value": "ZWE"
	    }
	  }, ["Zimbabwe"])
	}},function (){with(this) {
	  return _h('h3', ["Professional Details"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "organisation"
	    }
	  }, ["Organisation"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "speciality"
	    }
	  }, ["Speciality"])
	}},function (){with(this) {
	  return _h('h3', ["Website Registration"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "password"
	    }
	  }, ["Password"])
	}},function (){with(this) {
	  return _h('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "confirmpassword"
	    }
	  }, ["Confirm Password"])
	}},function (){with(this) {
	  return _h('h3', ["Agreement"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "col-sm-10"
	  }, [_h('p', {
	    staticClass: "form-control-static"
	  }, ["By checking this box you accept that..."])])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "form-group"
	  }, [_h('div', {
	    staticClass: "col-sm-12"
	  }, [_h('button', {
	    staticClass: "btn btn-default btn-block btn-info btn-lg",
	    attrs: {
	      "type": "submit"
	    }
	  }, ["Register"])])])
	}}]}

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [((this.currentUser && this.currentUser.type == 'administrator')) ? _h('div', {
	    staticClass: "container mainContent"
	  }, [_m(0), " ", _m(1), " ", _m(2), " ", _h('transition', {
	    attrs: {
	      "appear": "",
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_h('table', {
	    staticClass: "table table-condensed table-bordered table-striped"
	  }, [_m(3), " ", _h('tbody', [_l((users), function(user) {
	    return _h('tr', {
	      key: user['.key']
	    }, [_h('td', [_s(user.surname) + ", " + _s(user.forename)]), " ", _h('td', [_h('a', {
	      attrs: {
	        "href": 'mailto:' + user.email
	      }
	    }, [_s(user.email)])]), " ", _h('td', [_s(user.type)]), " ", _h('td', [_s(_f("epochtoreal")(user.entered))]), " ", _h('td', [_s(_f("epochtoreal")(user.emailopened))]), " ", _h('td', [_s(_f("epochtoreal")(user.inviteaccepted))]), " ", _h('td', {
	      staticClass: "text-center"
	    }, [(user.ai2016) ? _h('span', ["ai16,"]) : _e(), (user.scientificcommittee) ? _h('span', ["sc,"]) : _e()]), " ", _m(4, true), " ", _m(5, true), " ", _m(6, true)])
	  })])])])]) : _h('div', {
	    staticClass: "container mainContent"
	  }, [_h('h2', ["An error has occured"]), " ", _h('p', ["Sorry, but you're not authorised to view this page."])]), " "])
	}},staticRenderFns: [function (){with(this) {
	  return _h('h2', ["User Management"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "btn-group btn-group-justified",
	    attrs: {
	      "role": "group"
	    }
	  }, [_h('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "role": "group"
	    }
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, ["Add User"])]), " ", _h('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "role": "group"
	    }
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, ["Import Users"])])])
	}},function (){with(this) {
	  return _h('br')
	}},function (){with(this) {
	  return _h('thead', [_h('tr', [_h('th', ["Name"]), " ", _h('th', ["Email"]), " ", _h('th', ["User Level"]), " ", _h('th', ["Invite Sent"]), " ", _h('th', ["Opened"]), " ", _h('th', ["Accepted"]), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["Groups"]), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["-"]), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["-"]), " ", _h('th', {
	    staticClass: "text-right"
	  }, ["Functions"])])])
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('td', {
	    staticClass: "text-right"
	  }, [_h('div', {
	    staticClass: "btn-group btn-group-xs",
	    attrs: {
	      "role": "group",
	      "aria-label": "..."
	    }
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, ["Edit User"]), " ", _h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, ["Reset Password"]), " ", _h('button', {
	    staticClass: "btn btn-default btn-danger",
	    attrs: {
	      "type": "button"
	    }
	  }, ["Delete User"])])])
	}}]}

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', ["\n  Some Content Here\n"])
	}}]}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){with(this) {
	  return _h('nav', {
	    staticClass: "navbar navbar-default navbar-fixed-top"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "collapse navbar-collapse",
	    attrs: {
	      "id": "bs-example-navbar-collapse-1"
	    }
	  }, [_h('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(1)]), " ", _h('li', [_m(2), " ", _h('ul', {
	    staticClass: "dropdown-menu"
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/info_venue",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(3)]), " ", _h('router-link', {
	    attrs: {
	      "to": "/info_capetown",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(4)]), " ", _h('router-link', {
	    attrs: {
	      "to": "/info_2017committee",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(5)]), " ", _h('router-link', {
	    attrs: {
	      "to": "/info_delegateregistration",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(6)])])]), " ", _m(7), " ", _h('transition', {
	    attrs: {
	      "appear": "",
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(this.authData) ? _h('li', {
	    key: "authorised"
	  }, [_h('a', {
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_s(this.currentUser.forename) + " " + _s(this.currentUser.surname) + " ", (this.currentUser.type == 'administrator') ? _h('strong', ["(Admin) "]) : _e(), _m(8)]), " ", _h('ul', {
	    staticClass: "dropdown-menu"
	  }, [((this.authData && this.currentUser.type == 'administrator')) ? _h('router-link', {
	    attrs: {
	      "to": "/manageusers",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(9)]) : _e(), " ", ((this.authData && this.currentUser.type == 'administrator')) ? _h('router-link', {
	    attrs: {
	      "to": "/scregister",
	      "tag": "li",
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_m(10)]) : _e(), " ", _h('li', [_h('a', {
	    on: {
	      "click": userLogout
	    }
	  }, ["Logout"])])])]) : _h('li', {
	    key: "unauthorised"
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/login"
	    }
	  }, ["Login"])]), " "])])])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "navbar-header"
	  }, [_h('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#bs-example-navbar-collapse-1",
	      "aria-expanded": "false"
	    }
	  }, [_h('span', {
	    staticClass: "sr-only"
	  }, ["Toggle navigation"]), " ", _h('span', {
	    staticClass: "icon-bar"
	  }), " ", _h('span', {
	    staticClass: "icon-bar"
	  }), " ", _h('span', {
	    staticClass: "icon-bar"
	  })]), " ", _h('a', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "/"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": __webpack_require__(65)
	    }
	  })])])
	}},function (){with(this) {
	  return _h('a', ["About us"])
	}},function (){with(this) {
	  return _h('a', {
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, ["Conference Info ", _h('i', {
	    staticClass: "fa fa-angle-down"
	  })])
	}},function (){with(this) {
	  return _h('a', ["About the Venue"])
	}},function (){with(this) {
	  return _h('a', ["About Cape Town"])
	}},function (){with(this) {
	  return _h('a', ["AIDSImpact 2017 Committee"])
	}},function (){with(this) {
	  return _h('a', ["Delegate Registration"])
	}},function (){with(this) {
	  return _h('li', [_h('a', {
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, ["Previous Conferences ", _h('i', {
	    staticClass: "fa fa-angle-down"
	  })]), " ", _h('ul', {
	    staticClass: "dropdown-menu"
	  }, [_h('li', [_h('a', {
	    attrs: {
	      "href": "2015/",
	      "target": "_blank"
	    }
	  }, ["2015 - Amsterdam, NL"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2013/",
	      "target": "_blank"
	    }
	  }, ["2013 - Barcelona, Spain"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2011/",
	      "target": "_blank"
	    }
	  }, ["2011 - Santa Fe, USA"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2009/",
	      "target": "_blank"
	    }
	  }, ["2009 - Botswana"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2007/",
	      "target": "_blank"
	    }
	  }, ["2007 - Marseille"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2005/",
	      "target": "_blank"
	    }
	  }, ["2005 - Cape Town"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "2003/",
	      "target": "_blank"
	    }
	  }, ["2003 - Milan"])])])])
	}},function (){with(this) {
	  return _h('i', {
	    staticClass: "fa fa-angle-down"
	  })
	}},function (){with(this) {
	  return _h('a', ["Manage Users"])
	}},function (){with(this) {
	  return _h('a', ["Preview Scientific Committee Registration"])
	}}]}

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('footer', {
	    staticClass: "container-fluid footerBlock"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('h4', [_h('strong', [_h('u', ["D"]), "isclaimer"])]), " ", _h('p', ["\n      The information contained in this website is for general information purposes only. The information is provided by AIDSimpact and whilst we endeavour to keep the information up-to-date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.\n    "]), " ", _h('p', ["\n      In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of or in connection with the use of this website.\n    "]), " ", _h('p', ["\n      Through this website you are able to link to other websites which are not under the control of AIDSimpact . We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.\n    "]), " ", _h('p', ["\n      Every effort is made to keep the website up and running smoothly. However, AIDSimpact takes no responsibility for and will not be liable for the website being temporarily unavailable due to technical issues beyond our control.\n    "]), " ", _h('p', {
	    staticClass: "text-center"
	  }, ["\n      ©2017 - AIDSImpact\n    "])])])
	}}]}

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('div')
	}}]}

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [_h('div', {
	    staticClass: "container-fluid bg-primary frontBanner"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('transition', {
	    attrs: {
	      "appear": "",
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(this.authData) ? _h('div', {
	    key: "authorised",
	    staticClass: "row"
	  }) : _h('div', {
	    key: "unauthorised",
	    staticClass: "row"
	  }, [_h('div', {
	    staticClass: "col-lg-2"
	  }), " ", _h('div', {
	    staticClass: "col-lg-8"
	  }, [_h('h2', ["Enter your details to login."]), " ", _h('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        userLogin($event)
	      }
	    }
	  }, [_h('div', {
	    staticClass: "form-group"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (txtEmail),
	      expression: "txtEmail"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": _s(txtEmail)
	    },
	    on: {
	      "keydown": function($event) {
	        if ($event.keyCode !== 13) return;
	        $event.preventDefault();
	        focusNextField($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        txtEmail = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (txtPassword),
	      expression: "txtPassword"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": _s(txtPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        txtPassword = $event.target.value
	      }
	    }
	  })]), " ", _h('button', {
	    staticClass: "btn btn-default btn-block btn-info btn-lg",
	    attrs: {
	      "type": "submit"
	    }
	  }, ["Login"])]), " ", _h('h3', {
	    staticClass: "text-center"
	  }, [_h('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        userResetPassword($event)
	      }
	    }
	  }, ["Forgotten your password?"])]), " ", (messageError) ? _h('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageError)]) : _e(), " ", (messageSuccess) ? _h('div', {
	    staticClass: "alert alert-success",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageSuccess)]) : _e()]), " ", _h('div', {
	    staticClass: "col-lg-2"
	  })]), " "])])])])
	}},staticRenderFns: []}

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "container mainContent"
	  }, [_h('h2', ["AIDSImpact 2017 Committee"]), " ", _h('h3', ["Local Committee"]), " ", _h('ul', [_h('li', ["Mark Tomlinson"]), " ", _h('li', ["Sarah Skeen"]), " ", _h('li', ["Bridgette Prince – HSRC"]), " ", _h('li', ["Heidi van Rooyen – HSRC"]), " ", _h('li', ["Connie Kganakga – SANAC"]), " ", _h('li', ["Lifutso Motsieola – SANAC"]), " ", _h('li', ["Chris Colvin – UCT"]), " ", _h('li', ["Gita Ramjee"]), " ", _h('li', ["Wendee Wechsberg"]), " ", _h('li', ["Geoffrey Setswe – HSRC"]), " ", _h('li', ["Di Cooper – UWC"])]), " ", _h('h3', ["International Board"]), " ", _h('ul', [_h('li', ["Dr Jose Catalan"]), " ", _h('li', ["Dr Barbara Hedge"]), " ", _h('li', ["Prof Lorraine Sherr"]), " ", _h('li', ["Prof Lucie Cluver"]), " ", _h('li', ["Dr Richard Harding"]), " ", _h('li', ["Bridgette Prince – HSRC"]), " ", _h('li', ["Dr Bruno Spire"]), " ", _h('li', ["Dr Udi Davidovich"])]), " ", _h('h3', ["Logistics"]), " ", _h('ul', [_h('li', ["Maria Oud"]), " ", _h('li', ["Yoni Sherr"]), " ", _h('li', ["Jacob Taylor"])]), " ", _h('h3', ["International Scientific Advisory Board"]), "\n  TBC\n\n"])
	}}]}

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [_h('div', {
	    staticClass: "container-fluid bg-primary frontBanner"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('div', {
	    staticClass: "row"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "col-lg-8"
	  }, [_m(1), " ", _m(2), " ", (this.authData) ? _h('div') : _h('div', {
	    staticClass: "input-group input-group-lg"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      value: (txtEmail),
	      expression: "txtEmail"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Your email address"
	    },
	    domProps: {
	      "value": _s(txtEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) return;
	        txtEmail = $event.target.value
	      }
	    }
	  }), " ", _h('span', {
	    staticClass: "input-group-btn"
	  }, [_h('button', {
	    staticClass: "btn btn-default btn-info",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": subscribeForInfo
	    }
	  }, ["Please email me further information"])])]), " ", " ", (messageError) ? _h('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageError)]) : _e(), " ", (messageSuccess) ? _h('div', {
	    staticClass: "alert alert-success",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_s(messageSuccess)]) : _e()]), " ", _m(3)])])]), " ", _m(4)])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "col-lg-2"
	  })
	}},function (){with(this) {
	  return _h('h1', {
	    staticClass: "text-uppercase"
	  }, ["AIDS Impact", _h('br'), "13th International Conference"])
	}},function (){with(this) {
	  return _h('h2', ["November 13th - 15th 2017, Cape Town"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "col-lg-2"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "container aboutAIDSImpact text-center"
	  }, [_h('div', {
	    staticClass: "row"
	  }, [_h('div', {
	    staticClass: "col-lg-2"
	  }), " ", _h('div', {
	    staticClass: "col-lg-8"
	  }, [_h('h2', {
	    staticClass: "text-uppercase"
	  }, ["ABOUT ", _h('strong', ["AIDSIMPACT"])]), " ", _h('hr'), " ", _h('p', {
	    staticClass: "lead"
	  }, ["\n          AIDSImpact is an international behavioral and psychosocial science conference that addresses issues related to HIV/AIDS prevention, treatment and care, focusing both globally and on specific communities and countries hardest hit by the HIV/AIDS epidemic.\n        "]), " ", _h('p', {
	    staticClass: "lead"
	  }, ["\n          AIDSImpact first convened in Amsterdam in 1991. Now, in 2017 the 13th AIDSImpact conference will be held in Cape Town.\n        "]), " ", _h('p', {
	    staticClass: "lead"
	  }, ["\n          Each AIDSImpact meeting attracts delegates new to the field as well as a core group of loyal psychosocial and behavioral researchers, prevention workers, community members and policy makers from universities and institutes across all five continents who use the biannual meeting to present their studies, interventions and prevention schemes. AIDSImpact has evolved as one of the leading platforms for understanding, updating and debating the behavioral, psychosocial and community facets of HIV in light of changing social conditions and medical advances. In fact, a review of past AIDSImpact scientific programs reveals the evolution of the psychosocial and behavioral response to the HIV epidemic over the past 25 years.\n        "]), " ", _h('p', {
	    staticClass: "lead"
	  }, ["\n          The 2017 Cape Town conference will promote pioneering work on understanding the dynamics of a changing epidemic. A key focus will be consideration of new choices for HIV - for prevention, treatment, care and strategic planning.\n        "])]), " ", _h('div', {
	    staticClass: "col-lg-2"
	  })])])
	}}]}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "container mainContent"
	  }, [_m(0), " ", _m(1), " ", _m(2), " ", _m(3), " ", _m(4), " ", _m(5), " ", _m(6), " ", _m(7), _m(8), " ", _m(9), " ", _h('iframe', {
	    attrs: {
	      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.773802024184!2d18.502809315210943!3d-33.89547898064882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc5c112ae309a3%3A0x2e84748d4b1c112!2sCentury+City+Conference+Centre!5e0!3m2!1sen!2sza!4v1478123605580",
	      "width": "1170",
	      "height": "600",
	      "frameborder": "0",
	      "style": "border:0",
	      "allowfullscreen": ""
	    }
	  })])
	}},staticRenderFns: [function (){with(this) {
	  return _h('h2', ["Venue Information"])
	}},function (){with(this) {
	  return _h('h3', ["Address & Contact Details"])
	}},function (){with(this) {
	  return _h('p', [_h('a', {
	    attrs: {
	      "href": "http://www.ccconferencecentre.co.za"
	    }
	  }, [_h('strong', ["Century City Conference Centre and Hotel"])])])
	}},function (){with(this) {
	  return _h('address', ["\n    No. 4 Energy Lane", _h('br'), "\n    Bridgeways Precinct", _h('br'), "\n    Century City", _h('br'), "\n    7441\n  "])
	}},function (){with(this) {
	  return _h('p', ["\n    Tel nr: ", _h('a', {
	    attrs: {
	      "href": "tel:+27212048000"
	    }
	  }, ["+27 21 204 8000"])])
	}},function (){with(this) {
	  return _h('p', ["\n    Website: ", _h('a', {
	    attrs: {
	      "href": "http://www.ccconferencecentre.co.za"
	    }
	  }, ["http://www.ccconferencecentre.co.za"])])
	}},function (){with(this) {
	  return _h('h3', ["Site Map"])
	}},function (){with(this) {
	  return _h('img', {
	    attrs: {
	      "src": __webpack_require__(66)
	    }
	  })
	}},function (){with(this) {
	  return _h('br')
	}},function (){with(this) {
	  return _h('h3', ["Directions"])
	}}]}

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "container mainContent"
	  }, [_m(0), " ", _m(1), " ", _m(2), " ", _m(3), " ", _m(4), " ", _m(5), " ", _m(6), " ", _m(7), " ", _m(8), " ", _m(9), " ", _m(10), " ", _m(11), " ", _h('p', [_h('em', ["\n      Card payment facility issues - Contact details:", _m(12), "\n      Postal address: AIDSImpact Conference, Nieuwe Achtergracht 100, 1018 WT Amsterdam", _m(13), "\n      Phone number: 08444849447", _m(14), "\n      Email address (Card payment issues only): ", (true) ? _h('a', {
	    attrs: {
	      "href": "mailto:WPPCS5@aidsimpact.net"
	    }
	  }, ["WPPCS5@aidsimpact.net"]) : _e()])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('h2', ["Delegate Registration"])
	}},function (){with(this) {
	  return _h('h3', ["Prices"])
	}},function (){with(this) {
	  return _h('table', {
	    staticClass: "table"
	  }, [_h('thead', [_h('tr', [_h('th'), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["Early bird rates (Ends 28th Feb 2017)"]), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["Regular rates (Ends 31st Oct 2017)"]), " ", _h('th', {
	    staticClass: "text-center"
	  }, ["Late / On-site registration (From 1st Nov 2017)"])])]), " ", _h('tbody', [_h('tr', [_h('td', ["Regular participant"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€350"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€450"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€550"])]), " ", _h('tr', [_h('td', ["Low and middle income countries *"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€250"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€250"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€250"])]), " ", _h('tr', [_h('td', ["Student *"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€190"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€190"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€190"])]), " ", _h('tr', [_h('td', ["One day only *"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["-"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€76"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€76"])]), " ", _h('tr', [_h('td', ["Accompanying person *"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€63"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€63"]), " ", _h('td', {
	    staticClass: "text-center"
	  }, ["€63"])])])])
	}},function (){with(this) {
	  return _h('p', ["\n    All payment are to be made in Pound sterling (GBP).\n  "])
	}},function (){with(this) {
	  return _h('ul', [_h('li', ["\n      The Euro (EUR) prices are provided as guides and will vary with exchange rates on the day of payment.\n    "]), " ", _h('li', ["\n      The dates are based on the UK, GMT timezone.\n    "]), " ", _h('li', ["\n      Low-income and middle income economies, as determined by the World Bank.\n    "]), " ", _h('li', ["\n      Student identification must be produced onsite at registration to validate student status.\n    "]), " ", _h('li', ["\n      One day only registration allows access for any single day of your choice.\n    "]), " ", _h('li', ["\n      Accompanying person registration includes Opening and Closing ceremonies and the Welcome reception but no other sessions. Only one accompanying person per registered delegate.\n    "])])
	}},function (){with(this) {
	  return _h('h3', ["Insurance"])
	}},function (){with(this) {
	  return _h('p', ["Please note that AIDSImpact cannot be held responsible for any loss, damages or claims that delegates may incur. We advise that all delegates take their own travel and health insurance before travelling to the conference. "])
	}},function (){with(this) {
	  return _h('h3', ["Cancellation policy:"])
	}},function (){with(this) {
	  return _h('p', ["\n    Please note that the conference office should be notified of cancellations by e-mail (secretariat@AIDSImpact.com) . Due to financial obligations incurred, 50% of the paid conference fee will be refunded if the conference office receives your written cancellation by email before 1st August 2017. We regret that no refunds can be made for any cancellation received after 2nd August 2017. \n  "])
	}},function (){with(this) {
	  return _h('p', ["\n    If you cannot attend the conference, you may transfer your registration to another member of your organization at any time. Notification of transfer must be given in writing to the conference office (secretariat@AIDSImpact.com) prior to the conference. \n  "])
	}},function (){with(this) {
	  return _h('p', ["\n    'No shows' (due to all causes including natural disasters) are non-refundable and are liable for the full registration fee. \n  "])
	}},function (){with(this) {
	  return _h('hr')
	}},function (){with(this) {
	  return _h('br')
	}},function (){with(this) {
	  return _h('br')
	}},function (){with(this) {
	  return _h('br')
	}}]}

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "container mainContent"
	  }, [_h('h2', ["About Cape Town"]), " ", _h('h3', ["Cape Town – the mother city"]), " ", _h('p', ["\n    The capital of the Western Cape Province of South Africa, and one of four national capitals, Cape Town is a political, economic, and cultural hub. Cape Town lies along the Cape Peninsula, a region ensconced in mountains, and edged by the Indian and Atlantic oceans. Named the most beautiful city in the world in 2014, Cape Town is perhaps best known for its cultural ambience. Fine dining and the arts flourish in a region bordered by one of the Southern hemisphere’s older wine-growing regions. Cape Town is also home to two of the country’s oldest universities and teaching hospitals, saw the world’s first heart transplant, and – today – is characterised by a rich and lively academic culture. Cape Town is both tourist attraction and local haven, and – with its international airport, is a stepping stone between Africa, and the world.\n  "]), " ", _h('h3', ["Communications"]), " ", _h('ul', [_h('li', ["Roaming mobile network services are available in South Africa"]), " ", _h('li', ["If you wish to join a South African mobile network, you can buy or hire a cell phone at the airport or at most of the major shopping centres."]), " ", _h('li', ["Internet cafe charges are reasonable.  You will find Internet cafe facilities at some Cape Town Tourism Visitor Information Centres."]), " ", _h('li', ["Many hotels and accommodation establishments have wireless internet connections"])]), " ", _h('h3', ["Money"]), " ", _h('ul', [_h('li', ["The local currency is the South African rand. Foreign exchange facilities are widely available and can be found at the V&A Waterfront, Cape Town International Airport and at bureaux de change in various major shopping centres."]), " ", _h('li', ["Automated Teller Machines (ATMs) accept most international bank and credit cards."]), " ", _h('li', ["VAT: South Africa has a Value Added Tax system of 14% on purchases and services. Foreign visitors can reclaim VAT on collective purchases of more than R250. VAT Refund Offices can be found at: Ground level, International Departures, Cape Town International Airport Tel: + 27 21 934 8675."])]), " ", _h('h3', ["Tipping"]), " ", _h('ul', [_h('li', ["A 10% tip is standard in restaurants. Tables of over eight people often have an automatic service charge added to the bill. A tip of R5 to R10 per piece of luggage is acceptable for porters in hotels and at airports. In some shopping areas, uniformed attendants will either take a fee or offer to mind your car for a tip."]), " ", _h('li', ["It is not obligatory to tip an informal ‘car guard’ for services rendered. If you choose to tip, that is permissible, but informal guards are not allowed to ask for money, either before or after the service is supplied. A tip of R1 to R5 is acceptable."]), " ", _h('li', ["When parking in metered bays in the CBD (Central Business District), parking marshals wearing luminous bibs will approach you and ask you how long you intend to stay. You can pay by the half-hour in advance, and pay the balance upon your return if necessary. Ignoring the marshal is a popular local pastime, but, then again, so is imposing fines on motorists."])]), " ", _h('h3', ["Health tips"]), " ", _h('ul', [_h('li', ["High-quality tap (faucet) water is available across the city and it is both palatable and safe to drink straight from the tap."]), " ", _h('li', ["The quality of the food is excellent, and Cape Town has some of the top restaurants in the world."]), " ", _h('li', ["Medical facilities in Cape Town are world-class. There is an excellent network of both state and private hospitals."]), " ", _h('li', ["We have a warm sunny climate and you should wear sunscreen and a hat whenever you are out of doors during the day, particularly between 10am and 4pm."]), " ", _h('li', ["Hepatitis B inoculations are recommended for children up to the age of 12 who have not completed the series of injections as infants."]), " ", _h('li', ["Cape Town is not a malaria area."])]), " ", _h('h3', ["Security tips"]), " ", _h('ul', [_h('li', ["Avoid carrying large sums of cash, carrying cameras or video cameras in plain sight and leaving belongings unattended."]), " ", _h('li', ["Heed the advice of your hosts or locals on where to go after dark. Try not to walk alone."]), " ", _h('li', ["Do not allow strangers to assist you in any way at ATMs."]), " ", _h('li', ["Street children and beggars may approach you for a handout. Many social workers counsel against giving money to the children as it usually gets handed over to an older person or is used to purchase drugs."]), " ", _h('li', ["At night, park in a secure, well-lit area.\n  "])]), " ", _h('h3', ["Language"]), " ", _h('p', ["\n    While the most commonly spoken language in Cape Town is Afrikaans, English is most commonly understood.\n  "]), " ", _h('p', ["\n    But, as English is only one of South Africa’s 11 official languages, a strong vernacular has developed, and English-speaking visitors might have a hard time recognising some of the words. We’re a friendly bunch in Cape Town, so if you’re totally confused, just ask and we’ll have you speaking South African.\n  "])])
	}}]}

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "container mainContent"
	  }, [_h('h2', ["Test Page"]), " ", _h('p', ["You could have some other content here!"])])
	}}]}

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.889c3fb488bfbea6b30c.js
 **/